import { render, staticRenderFns } from "./Action.List.Admin.vue?vue&type=template&id=525a0ae9&"
import script from "./Action.List.Admin.vue?vue&type=script&lang=js&"
export * from "./Action.List.Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports